import { Link } from "react-router-dom";

import "./buttons.scss";

import { ReactComponent as Icon } from "../icons/left_arrow.svg";

export const BackButton = (props: {
  onClick?: () => void;
  link?: string;
}): JSX.Element => {
  if (props.link !== undefined) {
    return (
      <Link className="back rg-button" to={props.link}>
        <Icon />
      </Link>
    );
  } else {
    const onClick = () => {
      props.onClick && props.onClick();
    };

    return (
      <button className="back rg-button" onClick={onClick}>
        <Icon />
      </button>
    );
  }
};
